/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Grid, Typography, useMediaQuery } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { AiOutlineWechat } from "react-icons/ai";
import DivWrapper from 'components/Common/style/DivWrapper';
import LobbyChat from 'view/Chat/ChatComponent/LobbyChat';
import * as signalR from "@microsoft/signalr";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnIcon, BtnSend } from 'components/Common/Button';
import FeedChat from 'view/Chat/ChatComponent/FeedChat';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import { useLocation, useNavigate } from 'react-router-dom';
import { AxiosGet, ResultAPI } from 'service/CommonFunction/TS_function';
import { ImAttachment } from "react-icons/im";
import InputEmoji from 'react-input-emoji'
import DetailVOC from './DetailVOC';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';

const ChatFront = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const Layout1000 = useMediaQuery('(min-width:1000px)');

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const [connection, setConnection] = useState(null)
    const [Messages, setMessages] = useState([]);
    const [sVOCFormID, setsVOCFormID] = useState(location?.state ? location.state["sVOCFormID"] : null);
    const [nChatID, setChatID] = useState<number>(location?.state ? location.state["nChatID"] : 0);
    const nChatIDParam = location?.state ? location.state["nChatID"] : 0;
    // const [nChatID, setChatID] = useState<number>(location?.state ? location.state["nChatID"] : 0);
    const [nUserID, setUserID] = useState<number>(0);
    const [sPathImage, setPathImage] = useState<string>("");
    const [nContactID, setContactID] = useState<number>(0);


    const [users, setUsers] = useState(0);
    const [usersFrom, setusersFrom] = useState(0);

    const schema = yup.object().shape({
        sUser: yupFormSchemas.string("User", { required: false }),
        sRoom: yupFormSchemas.string("Room", { required: false }),
        sJobCode: yupFormSchemas.string("เลขที่ใบงาน", { required: false }),
        sVOCFormCode: yupFormSchemas.string("เลขที่ใบแจ้ง", { required: false }),
        oVOCType: yupFormSchemas.object("ประเภท", { required: false }),
        oVOCService: yupFormSchemas.object("บริการที่ต้องการ / ปัญหาที่พบ", { required: false }),
        sDetail: yupFormSchemas.string("รายละเอียด", { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        GetDataInitialForm();
    }, [])

    useEffect(() => {
        if (sVOCFormID != null) {
            GetDataVOCID();
        }
    }, [sVOCFormID])

    //Case Param In Page
    useEffect(() => {
        if (nChatIDParam != 0 && nUserID != 0) {
            GetContactID();
        }
    }, [location, nUserID])


    const GetDataInitialForm = async () => {
        await AxiosGet("User/GetUserData", { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                setUserID(res.result.nUserID || 0);
            })
        })
    };

    const GetDataVOCID = async () => {
        BlockUI();
        await AxiosGet(`VOC/VOCFormDataByID`, { sVOCFormID: sVOCFormID, "sLanguage": currentLanguage() }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {
                let Result = res?.result?.data
                if (Result != null) {
                    form.setValue("sVOCFormCode", Result.sVOCFormCode)
                    form.setValue("sJobCode", Result.sJobCode)
                    form.setValue("oVOCType", Result.objVOCType?.label == null ? null : Result.objVOCType)
                    form.setValue("oVOCService", Result.objVOCService?.label == null ? null : Result.objVOCService)
                    form.setValue("sDetail", Result.sDetail)
                }
            })
        })
    }
    const GetContactID = async () => {
        await AxiosGet(`VOC/GetCreateChatID`, { "nChatID": nChatID }, (res) => {
            ResultAPI(res, null, async () => {
                setContactID(res.nTo)
                await joinRoom(res.nChatID, res.nTo);
            })
        });
    }

    const joinRoom = async (nChatID, nContactID) => {
        try {
            setChatID(nChatID);
            setContactID(nContactID);

            const connection = new signalR.HubConnectionBuilder()
                .withUrl(process.env.REACT_APP_API_URL + "SignalRChat")
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.Information)
                .build();

            connection.on("SetChatRoom", (result) => {
                if (result.lstMessage != null && result.lstMessage.length > 0) {
                    //เอาข้อมูลแชทเก่า
                    setusersFrom(result.nFormUser)
                    setMessages([...result.lstMessage]);
                }
                else {
                    //Clear Data
                    setMessages([]);
                }
            });

            connection.on("ReceiveMessage", (result) => {
                setusersFrom(result.nFormUser)
                if (result.lstMessage != null && result.lstMessage.length > 0) {
                    //เอาข้อมูลแชทเก่า
                    setMessages(messages => [...messages, ...result.lstMessage]);
                }
            });

            connection.on("ReceiveImage", (result) => {
                let DIV_UPD_ID = document.getElementById("div_" + result.sKeyProgress) as HTMLDivElement;
                if (DIV_UPD_ID) {
                    let src = process.env.REACT_APP_API_URL + result.sPath + "/" + result.sSystemFileName;
                    let ImgAfterUpdate = "<img src=\"" + src + "\" style=\"height: 100%; width: 100%; max-height: 7vw;\" />";
                    DIV_UPD_ID.innerHTML = ImgAfterUpdate;
                }
            });

            connection.onclose(e => {
                setConnection(null);
                setMessages([]);
                setUsers(0);
            });

            await connection.start();
            let param = {
                nChatID: nChatID,
                nFormUser: nUserID
            }

            await connection.invoke("JoinRoom", param);
            setConnection(connection);
        } catch (e) {

        }
    }

    const sendMessage = async (message) => {
        try {
            let param = {
                nChatID: nChatID,
                nFormUser: nUserID,
                nToUser: nContactID,
                sMessage: message,
            }
            await connection.invoke("SendMessage", param);
        } catch (e) {

        }
    }
    const sendFile = async (item) => {
        try {
            let param = {
                nChatID: nChatID,
                nFormUser: nUserID,
                nToUser: nContactID,
                sFileName: item.name,
                sKeyProgress: item.sKeyProgress
            }
            await connection.invoke("FileMessage", param);
        } catch (e) {

        }
    }
    const sendDisplayImage = async (item) => {
        try {
            let param = {
                nChatID: nChatID,
                nMessageID: item.nMessageID,
                sKeyProgress: item.sKeyProgress
            }
            await connection.invoke("FileSuccessUpload", param);
        } catch (e) {

        }
    }
    const closeConnection = async () => {
        try {
            let param = {
                nChatID: nChatID,
                nFormUser: nUserID,
                nToUser: nContactID,
            }
            await connection.invoke("CloseConnection", param);
            await connection.stop();
        } catch (e) {

        }
    }
    const handleLobbyChatJoin = (sVOCFormID, nChatID, nContactID, sImagePerson) => {
        //Clear Chat Before
        closeConnection();
        setsVOCFormID(sVOCFormID);
        setChatID(nChatID);
        setContactID(nContactID);
        setPathImage(sImagePerson);
        joinRoom(nChatID, nContactID);
    }
    return (
        <>
            <div style={{ padding: !Layout1000 ? '2em 2em 0 2em' : '6em 2em 0 2em' }}>
                <InnerHeadRoutes
                    iconMUI={<AiOutlineWechat style={{ fontSize: '1.5em' }} />}
                    labal_Head={currentLanguage() == "th" ? "แชท" : "Chat"}
                />
                <div style={{ padding: '1em' }}>
                    <FormProvider {...form}>
                        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" >
                            <Grid item xs={12} sm={4} md={3}>
                                <LobbyChat handleLobbyChatJoin={handleLobbyChatJoin} nChatID={nChatID} users={nUserID} setPathImage={setPathImage}/>
                                {/* <LobbyChat joinRoom={joinRoom} closeConnection={closeConnection} users={nUserID} setsVOCFormID={setsVOCFormID} nChatID={nChatID} setChatID={setChatID} setPathImage={setPathImage} /> */}
                            </Grid>
                            <Grid item xs={12} sm={8} md={6}>
                                {/* #f2f7ff */}
                                <div style={{ height: '500px', backgroundColor: '#ffffff', border: '1px solid #d5d5d5 !important', borderRadius: '10px' }}>
                                    <FeedChat
                                        sendMessage={sendMessage}
                                        sendFile={sendFile}
                                        sendDisplayImage={sendDisplayImage}
                                        Messages={Messages}
                                        usersFrom={usersFrom}
                                        users={nUserID}
                                        chatID={nChatID}
                                        sPathImage={sPathImage}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} md={3} style={{ paddingTop: '16px' }}>
                                <div style={{ height: '500px', backgroundColor: '#fffffff2', borderRadius: '10px', padding: '1em', border: "1px solid #bdbdbd" }}>
                                    <DetailVOC />
                                </div>

                            </Grid>
                        </Grid>
                    </FormProvider>
                </div>

            </div>
        </>
    )
}

export default ChatFront